import { useState } from "react";
import { useNavigate } from "react-router-dom";


const Confirmed = () => {
const navigate = useNavigate();

  const [resendLoading, setResendLoading] = useState(false);


  const handleCancel = async () => {
    navigate(`/`);
  }


  return (
    <div className="confirm-page">
      <div className="confirm-container">

    <h2 style={{ color: "green", textAlign: "center", marginBottom: "20px", lineHeight: "1.5" }}>   
    🎉 Success! The Ticket Has Been Confirmed! 🎟️<br />
    </h2>

    <h4 style={{ color: "black", textAlign: "center", marginBottom: "20px", lineHeight: "1.5" }}>   
     User entry is now officially registered.<br />
     And all set to enter the event and enjoy!<br />
     </h4>



          <button
            onClick={handleCancel}
            disabled={resendLoading}
            className="otp-button"
          >
            {resendLoading ? "Redirecting..." : "Scan New Ticket"}
          </button>


      </div>
    </div>
  );
};

export default Confirmed;
